import React, { useState } from "react";
import styled from "styled-components";
import Button from "../Button/Button";
import Popup from "../Popup/Popup";
import imageProfile from "../../assets/images/profile/profileImage1.jpg";

function About() {
  const [open, setOpen] = useState(false);

  function buttonClick() {
    setOpen(!open);
  }

  return (
    <Container>
      <section className="about" id="about">
        <h1 className="about-title main-container">About</h1>
        <div className="about-container main-container">
          <div className="image-container">
            <img src={imageProfile} alt="Profile" className="image" />
          </div>
          <div className="info">
            <div className="about-text">
              <h4>Frontend</h4>
              <ul>
                <li>React.js | Next.js | Web Components</li>
                <li>TailwindCSS</li>
                <li>
                  Automated testing: Jest | Cypress | Selenium | AWS Device Farm
                </li>
                <li>Accessibility (WCAG, WAI-ARIA) | Semantic Web</li>
                <li>Collaborative design: Figma | Adobe XD</li>
              </ul>

              <h4>Backend / DevOps</h4>
              <ul>
                <li>Node.js | Java (Spring Boot)</li>
                <li>REST | GraphQL</li>
                <li>PostgreSQL | MySQL | MongoDB</li>
                <li>OAuth | JWT | RBAC</li>
                <li>Clean Architecture | SOLID principles</li>
                <li>Cloud deployment: Vercel | Netlify | AWS | Google Cloud</li>
                <li>CI/CD: GitHub Actions | Jenkins | GitLab</li>
                <li>Containers: Docker | Kubernetes</li>
                <li>Version control: Git | GitFlow | Monorepo</li>
              </ul>
            </div>
            <Button
              icon={<></>}
              children={"Download Resume"}
              onClick={() => buttonClick()}
            />
            <Popup open={open} buttonClick={buttonClick} />
          </div>
        </div>
      </section>
    </Container>
  );
}

export default About;

const Container = styled.div`
  section.about {
    background: var(--color-light);
    padding-bottom: 20rem;
  }

  .about-title {
    text-align: left;
    margin-bottom: 20px;
  }

  .image-container {
    border-radius: 5%;
    overflow: hidden;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .image-container img {
    width: 100%;
    height: auto;
    object-fit: cover;
    border-radius: 10px;
  }

  @media only screen and (min-width: 320px) {
    section.about .main-container {
      display: grid;
      grid-template-columns: 1fr;
      gap: 1rem;
      width: 90%;
    }
  }

  @media only screen and (min-width: 768px) {
    section.about .main-container {
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      align-items: center; /* <-- Centraliza imagem e texto */
      gap: 2rem;
      width: 90%;
    }
  }

  @media only screen and (min-width: 1200px) {
    section.about .main-container {
      display: grid;
      grid-template-columns: 26rem 50rem;
      align-items: center;
      gap: 5rem;
      width: 80%;
      justify-content: center;
      justify-items: center;
    }
  }

  .about-text h4 {
    font-size: 1.35rem;
    margin-top: 1.2rem;
    margin-bottom: 0.6rem;
    color: var(--color-primary);
    border-left: 4px solid var(--color-primary);
    padding-left: 0.6rem;
    font-weight: 600;
  }

  .about-text ul {
    list-style: disc;
    padding-left: 1.5rem;
    margin-bottom: 1rem;
  }

  .about-text li {
    margin-bottom: 0.45rem;
    line-height: 1.6;
    font-size: 1.05rem;
    color: var(--color-text);
  }
`;
